import primaryButton from '../../../../primary-button';

const custom = (params) => primaryButton.brandedSolid.background.active.custom(params);

export default custom;
